import _objectSpread from '@babel/runtime/helpers/objectSpread2';
function createRequestPayload(client, url) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';
  var data = arguments.length > 3 ? arguments[3] : undefined;
  var meta = arguments.length > 4 ? arguments[4] : undefined;
  var headers = arguments.length > 5 ? arguments[5] : undefined;
  var timeout = arguments.length > 6 ? arguments[6] : undefined;
  var _ref = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {},
    params = _ref.params;
  return {
    request: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      client: client,
      url: url,
      method: method
    }, data && {
      data: data
    }), meta && {
      meta: meta
    }), headers && {
      headers: headers
    }), timeout && {
      timeout: timeout
    }), params && {
      params: params
    })
  };
}
export default createRequestPayload;